<div>
  @if (data.title) {
  <h1 mat-dialog-title class='text-center' id="rmm_dialog_content_title">{{ data.title }}</h1>
  }
  <div id="rmm-alert-content" class="rmm-alert-text"
    [ngClass]="data.textAlign === 'left' ? 'text-left' : 'text-center'">
    <div [innerHTML]="data.html" [attr.id]="data.htmlId || null"></div>
  </div>
  <div class="footer">
    @if(data.confirmButtonText){
    <button id="rmm-alert-ok-btn" mat-button class="primary_btn" (click)="close(true)">
      {{ data.confirmButtonText }}
    </button>
    }
    @if(data.cancelButtonText){
    <button id="rmm-alert-cancel-btn" mat-button class="secondary_btn" (click)="close(false)">
      {{ data.cancelButtonText }}
    </button>
    }
  </div>
</div>